











































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getBase64FromUrl } from '@/utils/image';
import { fontUrlToDataBase6Uri } from '@/utils/fonts';
import { colorDefaultData } from '@/componentsV2/molecules/ColorPicker/colorsDictionary';
import flagKeys from '@/constants/flagKeys';

@Component({})
export default class CoinAnatomySafari extends Vue {
  @Prop({ default: '380' }) width?: string;
  @Prop({ default: '380' }) height?: string;
  @Prop() imagePath?: string;
  @Prop({ default: colorDefaultData.colorHex }) readonly fill?: string;
  @Prop({ default: '' }) readonly coinName?: string;
  @Prop({ default: 'coinAnatomyDef' }) readonly idDefDiv!: string;
  @Prop({ default: true }) coinShowFront?: boolean;
  @Prop({ default: false }) isLoading?: boolean;
  base64Img: string | null = null;
  idStyle: string = `${this.idDefDiv}-style`;

  @Watch('imagePath')
  async generateBase64CoinImg() {
    if (!this.imagePath) {
      this.base64Img = null;
      return;
    }
    this.base64Img = await getBase64FromUrl(this.imagePath);
  }

  async mounted() {
    if (this.imagePath && !this.base64Img) {
      this.generateBase64CoinImg();
    }

    const styleElement = document.getElementById(this.idStyle);

    if (styleElement) {
      return;
    }

    if (!this.coinShowFront) {
      const cssFontRules = await fontUrlToDataBase6Uri(
        'http://fonts.googleapis.com/css2?family=Inter'
      );

      if (!cssFontRules) {
        return;
      }

      const svgStyle = document.getElementById(this.idDefDiv);
      const fontStyle = document.createElement('style');

      if (!svgStyle) {
        return;
      }

      fontStyle.setAttribute('id', this.idStyle);
      fontStyle.setAttribute('type', 'text/css');
      fontStyle.textContent = cssFontRules.join(';');
      svgStyle.appendChild(fontStyle);
    }
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get coinImageIsOptional() {
    return this.flags.includes(flagKeys.npoCoinImageOptional);
  }

  get showPlaceholder() {
    return (!this.imagePath || this.isLoading) && this.coinShowFront;
  }

  get textStyle() {
    const style = [
      `font-family: 'Inter', sans-serif`,
      `font-style: normal`,
      `font-weight: 600`,
      `font-size: 40px`,
      `line-height: 48px`,
      `color: #fff`,
      `letter-spacing: 0.85px`,
      `text-shadow: -1.71px 2.375px 5.32px rgba(0, 0, 0, 0.16)`
    ];

    if (!this.coinName) {
      style.push(`mix-blend-mode:overlay`);
    }

    return style.join(';');
  }

  get tPrefix() {
    return 'common.components.coinAnatomy';
  }

  get textDefaultCoin() {
    return this.$t(`${this.tPrefix}.textDefaultCoin`);
  }

  get textCoin() {
    const text = this.coinName ? this.coinName : this.textDefaultCoin;
    return text.toString();
  }

  get hasLineBreak() {
    return this.textCoin.length > 11;
  }

  get coinNamePart1() {
    let part1 = this.textCoin;

    if (this.hasLineBreak) {
      part1 = this.textCoin.substr(0, 10);
    }

    return part1;
  }

  get coinNamePart2() {
    let part2 = '';
    if (this.hasLineBreak) {
      part2 = this.textCoin.substr(10, 20);
    }
    return part2;
  }
}
